<template>
  <div class="bread-con">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(item, index) in data" :key="'bread' + index">{{ item }}</el-breadcrumb-item>
      <!-- <el-breadcrumb-item><a href="/">活动管理</a></el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
      <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    data: {
      type: Array,
      default: () => ['']
    }
  }
}
</script>

<style lang="less" scoped>
.bread-con {
  height: 55px;
  box-sizing: border-box;
  padding-left: 16px;

  &>div {

    line-height: 55px;
  }

  ::v-deep .el-breadcrumb {
    font-size: 12px;

    &>span {
      &>span {
        color: rgba(0, 0, 0, 0.25);
      }

      &:last-child {
        &>.el-breadcrumb__inner {
          color: rgba(0, 0, 0, 0.85);
        }
      }
    }
  }
}
</style>
